<template>
  <div class="qa-container container">
    <h1>條款與細則</h1>
    <section>
      <h2>森女部落&nbsp;–&nbsp;隱私權政策</h2>
      <div class="text-box">
        <div class="black">隱私權政策聲明&nbsp;:</div>
        <div class="part">
          森女部落事業股份有限公司&nbsp;(&nbsp;以下稱「&nbsp;本公司&nbsp;」&nbsp;)&nbsp;經營森女部落官方網站，包含但不限於&nbsp;:<br />
        </div>
        <div class="part">
          https://cutecat8110.github.io/snbl/dist、App平台或其他相關應用程式&nbsp;(&nbsp;以下合稱「&nbsp;本網站&nbsp;」&nbsp;)
          為了維護個人隱私權與支持個人資料保護，本公司謹以下列聲明，向您說明本公司蒐集個人資料之目的、類別、利用方式、以及您所得行使之權利等事項。
        </div>
        當您使用我們的網站服務，即視為您同意本公司根據本隱私權聲明使用和保護您的個人資訊。<br />
        若您不同意本隱私權政策之全部或部分，請您停止使用我們的網站服務。
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black">一、隱私權保護政策的適用範圍</div>
        本隱私權政策僅適用於本網站對您個人資料所為蒐集、處理與利用，不涉及其他非本公司所有或控制之其他公司或個人。<br />
        本網站可能包含許多外部連結、或其他合作夥伴所提供的商品或服務，關於該等外部連結或合作夥伴網站之資料蒐集，
        請參考該連結網站之隱私權政策。
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black">二、個人資料的蒐集、類別及利用方式</div>
        <div class="part">
          為了提供電子商務服務、售後服務、履行合約義務、保護相關利害關係人之權益、行銷、客戶管理與經營等目的，
          會依照各服務之性質，當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，
          請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，
          本網站不會將個人資料用於其他用途。
        </div>
        <div class="part">
          本網站在您使用服務信箱、互動性聊天功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式、
          訂單資料及使用時間等，以處理和履行您的訂單，以及告知您訂單的狀態等客服問題。
        </div>
        <div class="part">
          進行一般網站瀏覽時，伺服器會自行記錄相關行徑，包括但不限於：您使用連線設備的&nbsp;IP&nbsp;位址、
          使用時間、使用的瀏覽器、瀏覽及點選資料等記錄、會員資料及其他得以直接或間接識別使用者身分之個人資料等，
          這些資料僅供本公司內部流量分析和網路行為調查之用，做為本公司增進網站服務的參考依據，有助於提升網站的瀏覽體驗。
        </div>
        為讓您能更輕易地接觸所偏好的商品資訊，我們會在不同平台對您作優化廣告投放及使用流程之目的範圍內，
        將您的個人資料分享給提供廣告分析、投放的服務業者如&nbsp;Google、Facebook、Line、Yahoo&nbsp;等第三人媒體
        &nbsp;/&nbsp;廣告&nbsp;/&nbsp;軟體業者，另該服務業者得以為您進行精準的商品廣告安排。
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black">三、與第三人共用個人資料之政策</div>
        <div class="part">
          本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。
        </div>
        <div class="part">前項但書之情形包括不限於&nbsp;:</div>
        <ul>
          <li>法律明文規定。</li>
          <li>
            基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。
          </li>
          <li>
            當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。
          </li>
          <li>與本公司協力廠商為執行相關活動必要範圍之利用。</li>
        </ul>
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black">四、資料保密及安全性</div>
        <div class="part">
          只由經過授權的人員才能接觸您的個人資料，如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。
        </div>
        <div class="part">
          為了保護您的帳戶及個人資料的安全，請您不要任意將個人帳號、
          密碼提供予第三人或允許第三人以您的個人資料申請帳號、密碼，否則，相關責任由您自行負擔。<br />
          若您的帳號、密碼有外洩之虞，請您立即更改密碼，或通知本公司暫停該帳號&nbsp;(&nbsp;本公司可能會要求核對您的個人資料&nbsp;)。
        </div>
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black">五、資料當事人之權利</div>
        <div class="part">
          資料當事人可以請求查詢、閱覽本人的個人資料或要求給予複本。<br />
          若您的個人資料有變更、或發現您的個人資料不正確，可以向本公司要求修改或更正；如您所提供之資料錯誤或缺漏，則不受本隱私權聲明之保護。
        </div>
        <div class="part">
          您可要求刪除、停止處理或利用個人資料，請與本公司客服聯絡，我們將會為您處理。
        </div>
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black">六、Cookie之使用</div>
        <div class="part">
          為了提供您良好的服務，本網站會在您的電腦中放置並取用我們的&nbsp;Cookie，
          若您不願接受&nbsp;Cookie&nbsp;的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，
          即可拒絕&nbsp;Cookie&nbsp;的寫入，但可能會導至網站某些功能無法正常執行。
        </div>
      </div>
    </section>
    <section>
      <div class="text-box">
        <div class="black">七、隱私權保護政策之修訂</div>
        <div class="part">
          本網站隱私權保護政策將因應需求隨時進行修訂，修正後的條款將刊登於網站上，
          不另行個別通知，如您在修訂後繼續使用我們的網站或服務即表示您完全接受這些修訂或變更。
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/stylesheets/custom/_variable';

.qa-container {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;

  h1 {
    margin-bottom: 1.5rem;
    text-align: center;
    text-indent: 0.25rem;
    letter-spacing: 0.25em;
    @include font-xl;
  }

  section {
    margin-bottom: 2.5rem;

    h2 {
      margin-bottom: 1rem;
      @include font-lg;
    }

    .text-box {
      color: $gray-600;

      .black {
        margin-bottom: 0.5rem;
        font-weight: 500;
        color: $gray-900;
      }

      .part {
        margin-bottom: 0.5rem;
      }

      .main {
        font-weight: 500;
        color: $color-main;
      }

      &:not(:last-child) {
        margin-bottom: 1rem;
      }

      a {
        color: #337ab7;
      }
    }
  }
}
</style>
